import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

import { ComparisonSearch } from '../components';
import {
  ComparisonSearchState,
  compareSearchDocuments,
  clearComparisonMessages,
  clearComparisionForSearch,
} from '../modules/comparisonSearch';
import {
  ComparisonDownloadState,
  downloadComparisonDocuments,
  clearComparisonDownloadedMessages,
} from '../modules/comparisonTsv';
import { UploadForSearchState } from '../modules/uploadForSearch';
import { goUploadSearchPage } from '../modules/pages';
import {
  ApplyState,
  ApplyContent,
  changeApplyContent,
  changeCategory,
  submitApplyContents,
  clearApplyContents,
  clearApplySuccessMessages,
  clearApplyErrorMessages,
} from '../modules/apply';
import 'core-js';

// configureStoreで設定した名前をセット
export function mapStateToProps(state: {
  comparisonSearch: ComparisonSearchState,
  comparisonTsv: ComparisonDownloadState,
  uploadForSearch: UploadForSearchState,
  apply: ApplyState,
}) {
  const { comparisonSearch, messages, status } = state.comparisonSearch;
  const {
    comparisonDownload,
    comparisonDownloadedSuccessMessages,
    comparisonDownloadedErrorMessages,
  } = state.comparisonTsv;
  const { files, filePatterns } = state.uploadForSearch;
  const { contents, successMessages, errorMessages } = state.apply;
  return {
    comparisonSearch,
    comparisonDownload,
    comparisonDownloadedSuccessMessages,
    comparisonDownloadedErrorMessages,
    files,
    filePatterns,
    messages,
    contents,
    successMessages,
    errorMessages,
    status,
  };
}

export function mapDispatchToProps(dispatch: ThunkDispatch<any, any, AnyAction>) {
  return {
    compareSearchDocuments:
      (fileIds: number[], fileTypes: string[]) => dispatch(compareSearchDocuments(fileIds, fileTypes)),
    clearComparisonMessages: () => dispatch(clearComparisonMessages()),
    goUploadSearchPage: () => {
      dispatch(goUploadSearchPage());
      dispatch(clearComparisionForSearch());
    },
    downloadComparisonDocuments:
      (fileIds: number[], fileTypes: string[]) => dispatch(
        downloadComparisonDocuments(fileIds, fileTypes)),
    clearComparisonDownloadedMessages: () => dispatch(clearComparisonDownloadedMessages()),
    changeApplyContent: (content: ApplyContent) => dispatch(
      changeApplyContent(content),
    ),
    changeCategory: (index: number, content: ApplyContent) => dispatch(
      changeCategory(index, content),
    ),
    submitApplyContents: (name: string, contents: ApplyContent[]) => dispatch(
      submitApplyContents(name, contents),
    ),
    clearApplyContents: () => dispatch(clearApplyContents()),
    clearSuccessMessages: () => dispatch(clearApplySuccessMessages()),
    clearErrorMessages: () => dispatch(clearApplyErrorMessages()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ComparisonSearch);



// WEBPACK FOOTER //
// ./src/containers/ComparisonSearch.tsx